import {$} from '../jquery-definition.js';

$( '.video-overlay' ).on( 'click', function( clickEvent ) {
	clickEvent.preventDefault();

	var $this = $( this );
	var $iframe = $this.parents( '.video' ).find( 'iframe' );

	$this.delay( 250 ).fadeOut( 500 );
	$iframe.attr( 'src', $iframe.attr( 'src' ) + '?autoplay=1' );
} );
